<!-- Breadcrumb/index.vue 需要修复可能的递归 -->
<template>
  <el-breadcrumb class="app-breadcrumb" separator="/">
    <transition-group name="breadcrumb">
      <el-breadcrumb-item v-for="(item, index) in levelList" :key="item.path">
        <span v-if="item.redirect === 'noredirect' || index == levelList.length-1" class="no-redirect">
          {{ item.meta.title }}
        </span>
        <router-link v-else :to="item.path">
          {{ item.meta.title }}
        </router-link>
      </el-breadcrumb-item>
    </transition-group>
  </el-breadcrumb>
</template>

<script>
export default {
  data() {
    return {
      levelList: null
    }
  },
  watch: {
    $route() {
      this.getBreadcrumb()
    }
  },
  created() {
    this.getBreadcrumb()
  },
  methods: {
    getBreadcrumb() {
      // 确保路径不是当前路径，避免循环
      let matched = this.$route.matched.filter(item => {
        // 添加检查避免循环
        if (item.path === '') return false
        if (item.redirect === item.path) return false
        return true
      })
      
      const first = matched[0]
      if (first && first.name !== 'home') {
        matched = [{ path: '/home', meta: { title: '首页' }}].concat(matched) //dashboard
      }
      
      this.levelList = matched
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Breadcrumb/index.vue